// extracted by mini-css-extract-plugin
export default {"categoryCard":"CategoryCardV2_categoryCard__C+Cem","catImageContainer":"CategoryCardV2_catImageContainer__rQPQu","categoryName":"CategoryCardV2_categoryName__MW5KA"};